import React from "react";

const CHART_VARIANTS = {
  line: "line",
  bar: "bar",
  pie: "pie",
};

const CHART_SKELETON_BY_ID = {
  dates: CHART_VARIANTS.line,
  labelCount: CHART_VARIANTS.bar,
  verifyDates: CHART_VARIANTS.line,
  verifyCount: CHART_VARIANTS.pie,
};

const LineBarSkeleton = () => (
  <div className="chart_skeleton_chart">
    {[100, 85, 70, 90, 60, 75].map((width, index) => (
      <div
        key={index}
        className="analytics-skeleton-bar analytics-skeleton-bar--horizontal"
        style={{ width: `${width}%` }}
      />
    ))}
  </div>
);

const BarSkeleton = () => (
  <div className="chart_skeleton_bars">
    {[65, 45, 80, 55, 70, 40].map((height, index) => (
      <div
        key={index}
        className="analytics-skeleton-bar analytics-skeleton-bar--vertical"
        style={{ height: `${height}%` }}
      />
    ))}
  </div>
);

const PieSkeleton = () => (
  <div className="analytics-skeleton-pie analytics-skeleton-bar" />
);

export const AnalyticsChartBlockSkeleton = ({
  variant = "line",
  chartId,
  message,
}) => {
  const resolvedVariant = variant || CHART_SKELETON_BY_ID[chartId] || "line";

  return (
    <div className="graph_item_loading_container">
      <div className="chart_skeleton_area">
        {resolvedVariant === CHART_VARIANTS.pie ? (
          <PieSkeleton />
        ) : resolvedVariant === CHART_VARIANTS.bar ? (
          <BarSkeleton />
        ) : (
          <LineBarSkeleton />
        )}
      </div>
      {message ? <p className="chart_skeleton_message">{message}</p> : null}
    </div>
  );
};
